@use '@design/design-tokens/typography/typography' as *;

.container {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  gap: 8px;
}

.labelWrapper {
  position: relative;
  height: 16px;
}

.labelText {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}

.styledTitle {
  @include typography-v2-body-sm;
  color: var(--text-default);
}

.styledDescription {
  @include typography-v2-body-xs;
  color: var(--text-soft);
}

.stepAndConnectorWrapper {
  display: flex;
  align-items: center;
}

.flexRow {
  display: flex;
  justify-content: space-between;
}
